import React from "react";
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls";
import { Permissions } from "../../../util/Permissions";
import { SubHeader } from "../../Common/layout/SubHeader";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import { FilterGroup } from "../../Common/components/FilterGroup";
import { SubscriptionTable } from "./SubscriptionsTable";
import { BillingsTable } from "./BillingsTable";

export const SubscriptionManagement = (
    {
        match: {
            params: { userGroup },
        },
    }
) => {
    return (
        <>
            <SubHeader>
                <SubHeader.Nav>
                    <SubHeader.NavItem label={"Subscriptions"} to={`/subscriptions/${userGroup}/all`} />
                    <SubHeader.NavItem label={"Billings"} to={`/subscriptions/${userGroup}/billings`} />
                </SubHeader.Nav>
            </SubHeader>
            <div className="py-4 px-6">
                <Switch>
                    <Redirect exact={true} from="/subscriptions/:userGroup" to="/subscriptions/:userGroup/all" />

                    <ContentRoute path="/subscriptions/:userGroup/all" permission={Permissions.SUBSCRIPTIONS}>
                        <FilterGroup>
                            <FilterGroup.Content className="mt-5">
                                {
                                    ({ filters }) => {
                                        return <SubscriptionTable userGroup={userGroup} />
                                    }
                                }
                            </FilterGroup.Content>
                        </FilterGroup>
                    </ContentRoute>
                    <ContentRoute path="/subscriptions/:userGroup/billings" permission={Permissions.SUBSCRIPTIONS}>
                        <Card>
                            <CardHeader title={`Billings`} />
                            <CardBody>
                                <BillingsTable userGroup={userGroup} />
                            </CardBody>
                        </Card>
                    </ContentRoute>
                </Switch>
            </div>
        </>
    );
};
